import { AxisSwitcher, Button, Col, H3, Hidden, P, ProductTile, Row, SpacerWrapper, TypeWrapper } from '@ahmdigital/ui';
import { CUSTOMER_NEEDS, NEEDS_PRODUCT_TYPE_SLUG } from '@ahmdigital/constants';
import { get, map } from 'lodash/fp';
import React from 'react';

import { ProductType } from '../../../../../types/product';
import constants from '../../../../../ahm-constants';
import PriceDisclaimer from '../../../../../components/price-disclaimer';
import styles from './styles.module.sass';

type ProductsSectionProps = {
  isLoadingPrice?: boolean;
  mlsAmount?: number;
  products: ProductType[];
};

const ProductsSection = ({ isLoadingPrice, mlsAmount, products }: ProductsSectionProps) => (
  <SpacerWrapper variant={styles.wrapper}>
    <Row>
      <Col df={12} variant="marginBottomSpacer9">
        <TypeWrapper variant="center">
          {/* @ts-expect-error - Automatic, Please fix when editing this file */}
          {mlsAmount > 0 ? (
            <H3>Here are some ahm products that might help with tax</H3>
          ) : (
            <>
              <H3>Having hospital cover is still a great idea.</H3>
              <P looksLike="h3" variant="regular">
                Get started with…
              </P>
            </>
          )}
        </TypeWrapper>
      </Col>
    </Row>
    <div className={styles.productTiles}>
      <AxisSwitcher limit={3} space="1rem" threshold="40rem">
        {map(({ content, url, ...restOfProps }) => (
          <div className={styles.productTileWrapper} key={url}>
            <ProductTile
              {...restOfProps}
              ctaVariant={['white', 'border']}
              isLoadingPrice={isLoadingPrice}
              key={url}
              linkTo={url}
              blurb={get('longForm')(content)}
              variant={styles.productTile}
            />
          </div>
        ))(products)}
      </AxisSwitcher>
    </div>

    <Row>
      <Col df={12} variant={styles.buttonWrapper}>
        <Button
          to={`${constants.URLS.SALES.PRODUCT_LISTING}/${CUSTOMER_NEEDS.TAX}/${NEEDS_PRODUCT_TYPE_SLUG.HOSPITAL}`}
          variant={styles.cta}
        >
          Compare covers
        </Button>
      </Col>

      <Col df={12} variant="marginBottomSpacer8">
        <div className={styles.disclaimerContainer}>
          <PriceDisclaimer bold showRefineLink constrainWidth forProducts={products} center />
        </div>
      </Col>
      <Col df={12} variant={styles.buttonWrapper}>
        <Hidden xs>
          <span className={styles.or}>Also interested in extras cover?</span>
        </Hidden>
        <Button to={constants.URLS.SALES.PRODUCT_LISTING_PACKAGES} variant={['border', 'white']}>
          View hospital & extras cover
        </Button>
      </Col>
    </Row>
  </SpacerWrapper>
);

ProductsSection.defaultProps = {
  isLoadingPrice: false,
  mlsAmount: 0,
};

export default ProductsSection;
